
//公用图片
Vue.component("course_cover", {
  props: {
      src: {
          type: String,
          required: true,
          default: ''
      },
      error_src: {
          type: String,
          default: ''
      },
      class_name: {
          type: String,
          default: ''
      },
      course_type: {
        default: 1
      }
  },
  data() {
      return {
          url: ''
      }
  },
  watch: {
    src: {
        handler(val) {
            this.url = val
        },
        immediate: true
    }
  },
//   created() {
//       this.url = this.src
//   },
  methods: {
      error() {
        let errSrc
        if(this.course_type == 0 || this.course_type == 1 || this.course_type == 2){
          errSrc = '/learn/static/imgs/course_cover/1.png'
        }else{
          errSrc = '/learn/static/imgs/other-course-bg.jpg'
        }
        if(this.error_src) errSrc = this.error_src
        this.url = errSrc
      }
  },
  template: `
      <img
          :src="url"
          :class="class_name"
          @error="error"
          alt=""
          referrerpolicy="no-referrer"
      />`
});